import React, { useEffect } from 'react';

export const ClutchCard = ({ text }: any) => {
  // TODO: fix types;
  useEffect(() => {
    // @ts-ignore
    if (window?.CLUTCHCO && !window.CLUTCHCO.loaded) {
      // @ts-ignore
      window.CLUTCHCO.Init();
    }
  }, []);

  return (
    <a
      className={'clutch-card'}
      href={'https://clutch.co/profile/qodeca#summary'}
      rel="noreferrer"
      target={'_blank'}
    >
      <p className={'clutch-card__text'}>{text}</p>
      <div
        className="clutch-widget"
        data-url="https://widget.clutch.co"
        data-widget-type="2"
        data-expandifr="true"
        data-height="38"
        data-clutchcompany-id="568337"
        data-primary-color="#F94743"
      />
    </a>
  );
};
